import React from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link, Tooltip } from '@mui/material';

export default function ChatStaffViewLink({ chatId }: { chatId: string }) {
  const url = `https://luxuryescapes.com/au/trip-planner/chat-trip-planner/${encodeURIComponent(chatId)}?staffView=1`;
  return (
    <Tooltip title={url}>
      <Link
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        variant="body2"
        sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' }}
      >
        Open staff view <OpenInNewIcon fontSize="inherit" />
      </Link>
    </Tooltip>
  );
}
